import VueHtml5Editor from 'vue-html5-editor'
import Vue from 'vue';
Vue.use(VueHtml5Editor);
